import { FC, useState } from 'react'
import { DonoTrain, DonoTrainSettings } from '@ailenax-overlay/shared'
import { DonoTrainWidget } from '@/Components/DonoTrainWidget/DonoTrainWidget';
import { useSocketCallback } from '@/hooks/useSocketCallback';
import { useSocketEvent } from '@/hooks/useSocketEvent';
import { useConfigMode } from '@/hooks/useConfigMode';

export const DonoTrainOBSWidget: FC = () => {
  const inConfigMode = useConfigMode();
  const [train, setTrain] = useState<DonoTrain | null>(null);
  const [offset, setOffset] = useState<number>(0);
  const [settings, setSettings] = useState<DonoTrainSettings | null>(null);

  useSocketEvent("dono-train", (e) => {
      setTrain(e.train);
      setOffset(Date.now() - e.timeReference.getTime());
  });

  useSocketEvent("dono-train-settings-update", (e) => {
      setSettings(e.settings);
  });

  useSocketCallback("get-dono-train", (train, timeReference) => {
      setTrain(train);
      setOffset(Date.now() - timeReference.getTime());
  });
  useSocketCallback("get-donotrain-settings", setSettings);

  /*
  useEffect(() => {
    setTrain({
      id: "123",
      status: "in-progress",
      level: 10,
      total: 5000,
      progress: 50,
      required: 100,
      record: {
        level: 10,
        percent: 90,
      },
      startedAt: new Date(),
      expiresAt: new Date(Date.now() + 1000 * 60 * 5),
    });
  }, []);
  */

  return train && (
    <div className="w-full flex justify-center">
      <DonoTrainWidget boxMode={settings?.boxMode} train={train} inConfigMode={inConfigMode} offset={offset} goals={settings?.goals} />
    </div>
  );
}